import type { StaffRole } from '@ucp/web/lib';

/**
 * Route-guard role arrays for the Purchasing ("Buy Something via Amazon Business")
 * surfaces (PRO-0980 Track A, ADR-048). Kept in a dependency-light module (imported
 * synchronously by `AppRoutes`) so the lazy surface stays out of the initial chunk —
 * mirrors `commercialRoles.ts` / `atrRoles.ts`.
 *
 * Guard-only / defence-in-depth (SF-SEC-001): the server `requirePurchasing*Enabled`
 * + `requireCapability('purchase_request' | 'purchase_reconcile')` gates stay
 * authoritative. `L6_PLATFORM_ADMIN` is DELIBERATELY absent from both (EoP).
 */

/**
 * The buy path (`/finance/buy-something/*`) — a principal records an attributed order.
 * PRO-3070: `L1_SENDER` is not a buyer. Chrome and this guard stay the same list.
 */
export const PURCHASING_BUYER_ROLES: StaffRole[] = ['PRINCIPAL'];

/** The reconcile path (`/finance/reconciliation/*`) — the AP reconciler works the queue. */
export const PURCHASING_RECONCILE_ROLES: StaffRole[] = ['AP_RECONCILER'];
